import { createContext } from 'react';

import { IUser } from '../_schema';

interface IAppContext {
  user: IUser;
  loginUser?: any;
  logoutUser?: any;
}

const AppContext = createContext<IAppContext>({
  user: { isLoggedIn: false, name: '' },
});
export { AppContext };
